import { render, staticRenderFns } from "./BudgetGroupedHeader.vue?vue&type=template&id=8735c81e"
import script from "./BudgetGroupedHeader.vue?vue&type=script&lang=js"
export * from "./BudgetGroupedHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports